import { render, staticRenderFns } from "./MarketingSitesTerms.vue?vue&type=template&id=1f7bf326"
import script from "./MarketingSitesTerms.vue?vue&type=script&lang=js"
export * from "./MarketingSitesTerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports